import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import DropdownModalForm from 'common/components/modal_dropdown_form';
import { messageActions } from 'admin/ducks/projects';
import { updateMessage, deleteMessage } from 'common/ducks/message';

const forms = (wrapup) => {
  if (wrapup) {
    return ([{
      label: 'Update Message',
      formName: 'update_message',
      show: true,
      fields: [{
        name: 'body',
        label: 'Updated Message',
        type: 'textarea',
      }]
    }, {
      label: 'Delete Message',
      formName: 'delete_message',
      show: true,
      pre: "Are you sure you want to permanently delete this message?",
      fields: []
    }]);
  }

  return ([{
    label: 'Update Message',
    formName: 'update_message',
    show: true,
    fields: [{
      name: 'body',
      label: 'Updated Message',
      type: 'textarea',
    }, {
      name: 'project_admin_note',
      label: 'Admin Note',
      type: 'textarea',
    }]
  }, {
    label: 'Hide Message',
    formName: 'hide_message',
    show: true,
    fields: [{
      name: 'project_admin_note',
      label: 'Admin Note',
      type: 'textarea',
    }]
  }]);
}

export function mapStateToProps(state, { message, wrapup }) {
  return {
    forms: forms(wrapup),
    form: `MESSAGE_ADMIN_FORM_${message.id}`,
    initialValues: {
      body: message.body
    }
  };
}

export function mapDispatchToProps(dispatch, { params, message, wrapup, wrapupStep }) {
  let submitAction;

  if (!wrapup) {
    submitAction = partial(messageActions, params.projectId, message.id);
  } else {
    submitAction = (formName, data) => (
      formName === "update_message"?
      updateMessage(message.id, data, wrapup, wrapupStep) :
      deleteMessage(message.id, wrapup, wrapupStep)
    );
  }

  return bindActionCreators({
    submitAction
  }, dispatch);
}

const Formify = reduxForm()(DropdownModalForm);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Formify));



// WEBPACK FOOTER //
// ./admin/containers/message_dropdown.js